import { environment } from '../../../environments/environment';

// Authentication endpoints
export const CSRF_ENDPOINT = `${environment.apiBaseUrl}/public/auth/csrf`;
export const LOGIN_ENDPOINT = `${environment.apiBaseUrl}/public/auth/login`;
export const LOGOUT_ENDPOINT = `${environment.apiBaseUrl}/public/auth/logout`;
export const SESSION_ENDPOINT = `${environment.apiBaseUrl}/internal/auth/session`;
